import fetch from 'isomorphic-fetch';

export const HEADERS = {
  JSON: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

export function apiRequest(url, options) {
  return fetch(url, Object.assign({ credentials: 'include' }, options))
    .then(response => {
      if (response.ok) {
        return response.json().then((data) => ({ response: data }));
      }

      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/json') !== -1) {
        return response.json()
          .then((json) => ({ error: json, status: response.status }));
      }
      return response.text()
        .then((text) => ({ error: text, status: response.status }));
    }, error => { console.log(error); });
}

export function putApiRequest(url, body, options = { headers: {} }) {
  return apiRequest(url, {
    ...options,
    method: 'PUT',
    headers: {
      ...options.headers,
      ...HEADERS.JSON,
    },
    body: JSON.stringify(body),
  });
}

export function postApiRequest(url, body, options = { headers: {} }) {
  return apiRequest(url, {
    ...options,
    method: 'POST',
    headers: {
      ...options.headers,
      ...HEADERS.JSON,
    },
    body: JSON.stringify(body),
  });
}


export function deleteApiRequest(url, options = { headers: {} }) {
  return apiRequest(url, {
    ...options,
    method: 'DELETE',
    headers: options.headers,
  });
}

export function sendFormData(url, data, method = 'POST', options = { headers: {} }) {
  const body = new FormData();
  Object.keys(data).forEach((key) => {
    if (data[key] instanceof FileList) {
      for (let i = 0; i < data[key].length; i++) {
        body.append('attachment', data[key][i], data[key][i].name);
      }
    }
    body.append(key, data[key]);
  });

  return apiRequest(url, {
    ...options,
    method,
    headers: {
      ...options.headers,
      Accept: 'application/json',
    },
    body,
  });
}

export function sendFileRequest(url, file, options = { headers: {} }) {
  const formData = new FormData();
  formData.append('attachment', file, file.name);

  return apiRequest(url, {
    ...options,
    method: 'POST',
    headers: {
      ...options.headers,
      Accept: 'application/json',
    },
    body: formData,
  });
}



/** WEBPACK FOOTER **
 ** ./js/core/api/_tools.js
 **/